import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchTradeDetailsAction } from '../store/reducer/tradeDetailsSlice';

const POLLING_INTERVAL_MS = 30000; // 30 seconds

export const useTradeDetilas = () => {
  const { propertyType = 'secondary', propertyId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isComponentMounted = useRef(true);

  const state = useSelector((state) => state.tradeDetails);
  const onFetchFail = () => {
    if (location?.state?.prevPath) {
      navigate(location.state.prevPath);
      return;
    }
    navigate(`/property/${propertyType}/${propertyId}`);
  };
  async function fetchTradeDetails() {
    await dispatch(fetchTradeDetailsAction({ id: propertyId, onFail: onFetchFail }));
  }

  useEffect(() => {
    if (!state.loading) {
      fetchTradeDetails();
    }

    const pollingTimer = setInterval(() => {
      if (isComponentMounted.current) {
        fetchTradeDetails();
      }
    }, POLLING_INTERVAL_MS);

    return () => {
      isComponentMounted.current = false;
      clearInterval(pollingTimer);
    };
  }, [propertyId.loading]);

  return {
    fetchTradeDetails,
  };
};
